import type { WidgetDefinition, WidgetPresentationType, DomainCategory } from '../../types';

export interface WizardFormData extends Partial<WidgetDefinition> {
  nombre: string;
  descripcion: string;
  categoria: DomainCategory;
  tipo: WidgetPresentationType;
  icono: string;
  roles_permitidos: string[];
  col_min: number;
  col_max: number;
  cols_default: number;
  altura_default: number;
  activo: boolean;
  endpoint_url: string;
  endpoint_method: 'GET' | 'POST';
  endpoint_headers: Record<string, string>;
  endpoint_params: Record<string, string | number | boolean>;
  refresh_policy: number;
  es_privado: boolean;
  is_internal: boolean;

  // ── Catálogo de indicadores económicos ──────────────────────
  /** Modo de selección de fuente de datos */
  catalog_mode: 'catalogo' | 'manual';
  /** ID del indicador seleccionado del catálogo */
  catalog_indicator_id?: string;
  /** API Key para indicadores que la requieren (ej: FRED) */
  catalog_api_key: string;
  /** Path al campo valor en la respuesta (pre-fill desde catálogo) */
  campo_valor: string;
  /** Path al campo fecha en la respuesta (pre-fill desde catálogo) */
  campo_fecha: string;
}

export interface WizardState {
  formData: WizardFormData;
  testSuccess: boolean;
  isTesting: boolean;
  jsonPreview: Record<string, unknown>[] | null;
  mappingX: string;
  mappingY: string;
}

export const INITIAL_FORM_DATA: WizardFormData = {
  nombre: '',
  descripcion: '',
  // Sin categoría: la elige el usuario entre las que declara el host. Antes nacía en
  // 'Operaciones', una categoría de Siesa Comercial que en otro host no existe.
  categoria: '' as DomainCategory,
  tipo: 'kpi' as WidgetPresentationType,
  icono: 'Layout',
  roles_permitidos: ['admin'],
  col_min: 2,
  col_max: 12,
  cols_default: 3,
  altura_default: 1,
  activo: true,
  endpoint_url: '',
  endpoint_method: 'GET',
  endpoint_headers: {},
  endpoint_params: {},
  refresh_policy: 300,
  es_privado: true,
  is_internal: true,
  // Catálogo
  catalog_mode: 'catalogo',
  catalog_indicator_id: undefined,
  catalog_api_key: '',
  campo_valor: '',
  campo_fecha: '',
};
